import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal lp-speedbump",
  id: "dxfOffsiteModal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "modal-footer border-0" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "modal-backdrop lp-speedbump-backdrop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", { innerHTML: $setup.messageHtml }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              href: $setup.modalUrl,
              target: "_blank",
              class: "btn btn-primary btn-round offsite-link me-3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
            }, _toDisplayString($props.proceedButtonText), 9, _hoisted_7),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary btn-round",
              "data-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
            }, _toDisplayString($props.stayButtonText), 1)
          ])
        ])
      ])
    ]),
    ($props.backdrop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
      : _createCommentVNode("", true)
  ], 64))
}